import { CREATE_CREDIT_NOTE, FETCH_CREDIT_NOTE, FETCH_CREDIT_NOTES } from "./types";

import { ITEMS_PER_PAGE } from "../../constants/constants";

const INITIAL_STATE = {
  creditNoteDetail: {
    creditNote: null,
    loading: false,
    error: null,
  },
  creditNoteList: {
    creditNotes: [],
    loading: false,
    error: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // --------------------------------------------------------------------------
    // CREATE_CREDIT_NOTE
    // FETCH_CREDIT_NOTE
    // --------------------------------------------------------------------------
    case CREATE_CREDIT_NOTE.init:
    case FETCH_CREDIT_NOTE.init:
      return {
        ...state,
        creditNoteDetail: { ...state.creditNoteDetail, error: null, loading: true },
      };
    case CREATE_CREDIT_NOTE.success:
    case FETCH_CREDIT_NOTE.success:
      return {
        ...state,
        creditNoteDetail: { ...state.creditNoteDetail, creditNote: action.payload, error: null, loading: false },
      };
    case CREATE_CREDIT_NOTE.failure:
    case FETCH_CREDIT_NOTE.failure:
      return {
        ...state,
        creditNoteDetail: {
          ...state.creditNoteDetail,
          creditNote: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_CREDIT_NOTES
    // --------------------------------------------------------------------------
    case FETCH_CREDIT_NOTES.init:
      return {
        ...state,
        creditNoteList: { ...state.creditNoteList, error: null, pages: undefined, loading: true },
      };
    case FETCH_CREDIT_NOTES.success:
      return {
        ...state,
        creditNoteList: {
          ...state.creditNoteList,
          creditNotes: action.payload.results,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_CREDIT_NOTES.failure:
      return {
        ...state,
        creditNoteList: {
          ...state.creditNoteList,
          creditNotes: null,
          pages: undefined,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    default:
      return state;
  }
};
